/**
 * UITracker implements a way to easily track standard analytics events in the UI.
 *
 * @example
 * import track from 'scripts/presentation/components/lib/track';
 *
 * <MyButton onClick={track.click('my-button', onClick)} />
 */
class UITracker {
  /**
   * click should be called to record a click has taken place
   *
   * @param {String} name
   * @param {callback} onClick
   */
  click(name, onClick) {
    return (...args) => {
      this.track('Component Clicked', { name });
      return onClick(...args);
    };
  }

  /**
   * track is called whenever an event happens, this should be overridden in
   * the `configure` method below to send the proper data to the analytics
   * backend of choice
   *
   * @param {String} eventName
   * @param {*} meta
   */
  track(eventName, meta) {
    // noop by default, this should be overwritten by using the configure method
  }

  /**
   * Set the track function. This is called when an event takes place.
   * Implementations should send the data to the analytics backend of choice.
   *
   * @callback trackCallback
   * @param {String} eventName - the name of the event
   * @param {*} meta - any metadata associated with the event
   *
   * @param {trackCallback} trackFn
   */
  configure(trackFn) {
    this.track = trackFn;
  }
}

export default new UITracker();



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/track.js